import { Elm } from "./Main.elm";


var app = Elm.Main.init({
	node: document.querySelector("main"),
});
app.ports.setItem.subscribe(function(keyValue) {
	localStorage.setItem(keyValue.key, keyValue.value);
});
app.ports.getItem.subscribe(function(key) {
	app.ports.gotItem.send({
		key: key,
		value: localStorage.getItem(key),
	});
});
